import { WEBCHAT_VISITOR_IDENTIFIER_PREFIX } from 'modules/webchat/domain/constants';
import {
  IWebchatIdentity,
  TWebchatVisitorType,
} from 'modules/webchat/domain/entities';

const VISITOR_IDENTIFIER_PATTERN = new RegExp(
  `^${WEBCHAT_VISITOR_IDENTIFIER_PREFIX}[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$`,
  'i',
);
const E164_PHONE_PATTERN = /^\+[1-9]\d{7,14}$/;
const VISITOR_TYPES: TWebchatVisitorType[] = ['cadastrado', 'novo'];

const isVisitorType = (value: unknown): value is TWebchatVisitorType =>
  VISITOR_TYPES.some(type => type === value);

/**
 * Aceita só a identidade que o pré-chat monta (buildVisitorWebchatIdentity):
 * identifier visitante-<uuid v4>, nome, celular E.164 e tipo cadastrado ou
 * novo. O resultado nunca leva customerId, para que um valor editado no
 * navegador não apareça ao atendente como um cliente do Vectis. Qualquer
 * outra coisa devolve null.
 */
export default function parseVisitorWebchatIdentity(
  value: unknown,
): IWebchatIdentity | null {
  if (typeof value !== 'object' || value === null) return null;

  const { identifier, name, phone, type } = value as Record<string, unknown>;

  if (
    typeof identifier !== 'string' ||
    !VISITOR_IDENTIFIER_PATTERN.test(identifier) ||
    typeof name !== 'string' ||
    !name.trim() ||
    typeof phone !== 'string' ||
    !E164_PHONE_PATTERN.test(phone) ||
    !isVisitorType(type)
  ) {
    return null;
  }

  return { identifier, name: name.trim(), phone, type };
}
